import React, { Component, PropTypes } from 'react';
import { extractVenueName, formatEventAddress } from '../../util/EventUtil';
import { commonPropTypes, EMPTY_TABLE_CELL } from '../../util/constants';

export default class EventVenueName extends Component {
  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE.isRequired
  };

  render() {
    const { event } = this.props;
    const location = event.accountEventData.length && event.accountEventData[ 0 ].event.location ?
      formatEventAddress(event.accountEventData[ 0 ].event.location.address) : null;

    return <span>{extractVenueName(event) || location || 'TBA'}</span>;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/event/EventVenueName.jsx